import { withRouter, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PageGateway = ({ history, pageAttr }) => {
  const subscription = useSelector((state) => state.subscription);

  const path = {
    plan: '/plano',
    customize: '/personalizar',
    customQuantity: '/quantidade-personalizada',

    frequency: '/frequencia',
    customFrequency: '/frequencia-personalizada',
  }[subscription[pageAttr]];

  if(path){
    return <Redirect to={path} />
  }
  else return null;
}

export default withRouter(PageGateway);
